// extracted by mini-css-extract-plugin
module.exports = {"totalsWrapper":"YLTwsj","tableWrapper":"HQCqZG"};